const request = require('./request')

export function list(args) {
	return request.get(`/topics/list`, args)
}

export function update(args) {
	return request.post(`/topics/update`, args)
}

export function remove(args) {
	return request.post(`/topics/remove`, args)
}

export function insert(args) {
	return request.post(`/topics/insert`, args)
}